import React, { Component } from 'react';



class AdvancePaymentInvoicesModal extends Component {

   

    render() {
        const {ShowAdvancePaymentInvoicesModal}= this.props
       
        return (
            <div>
                <div className="modal fade" id="advancePaymentInvoicesModal" data-keyboard="false" tabIndex="-1" aria-labelledby="advancePaymentInvoicesModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-xl modal-dialog-centered" >
                        <div className="modal-content">
                            {/* <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> */}
                        
                            <div className="modal-body">
                                <div className="row">
                                    <h4 className="modal-title ml-4" >Facturas de anticipo</h4>
                                </div>
                                <div className="container-fluid mt-3">
                                    <div className='row'>
                                        <div className='col-4'></div>
                                        <div className='col-4 text-center'>
                                           
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className='scrollTableGrossProfit'>
                                                <table className="table table-striped table-hover">
                                                    <thead >
                                                        <tr>
                                                            <th className="text-center">No. Documento</th>
                                                            <th className="text-center">Folio</th>
                                                            <th className="text-center">Tipo</th>
                                                            <th className="text-center">Comentarios</th>
                                                            <th className="text-center">importe bruto</th>
                                                            <th className="text-center">Impuesto</th>
                                                            <th className="text-center">Importe neto</th>
                                                            <th className="text-center">importe bruto pendiente</th>
                                                            <th className="text-center">Impuesto pendiente</th>
                                                            <th className="text-center">Importe neto pendiente</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                       
                                                        <tr >
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">2</td>
                                                            <td className="text-center">3</td>
                                                            <td className="text-center">4</td>
                                                            <td className="text-center">5</td>
                                                            <td className="text-center">6</td>
                                                            <td className="text-center">7</td>
                                                            <td className="text-center">8</td>
                                                            <td className="text-center">9</td>
                                                            <td className="text-center">10</td>
                                                        </tr>
                                                           
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { ShowAdvancePaymentInvoicesModal()}}>Cerrar</button>
                                {/* <button type="button" className="btn btn-primary" data-dismiss="modal"onClick={() =>ShowAdvancePaymentInvoicesModal()}>Algo</button> */}
                                        
                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdvancePaymentInvoicesModal;